
type ConsentStatus = 'accepted' | 'declined' | null;

interface ConsentData {
  status: ConsentStatus;
  timestamp: number;
  version: string;
}

const CONSENT_KEY = 'cookie-consent-status';
const CONSENT_VERSION = '1.0';

export const getConsentStatus = (): ConsentData | null => {
  const stored = localStorage.getItem(CONSENT_KEY);
  if (!stored) return null;
  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

export const setConsentStatus = (status: ConsentStatus): void => {
  const consentData: ConsentData = {
    status,
    timestamp: Date.now(),
    version: CONSENT_VERSION
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consentData));
  
  if (status === 'accepted') {
    window.gtag('consent', 'update', {
      'analytics_storage': 'granted'
    });
  } else {
    window.gtag('consent', 'update', {
      'analytics_storage': 'denied'
    });
  }
};
